import Debug from 'debug';
import { getSupportedSources, getSupportedConnectors, getSupportedTargets } from '../../helpers/api.js';

const debug = Debug('commands:env:validators');

export const validateAvailableSources = async (forkedSources, clientApiBaseUri, apikey, flows, env) => {

    if (!Array.isArray(forkedSources)) {
      throw new Error(`availableSources.json must be an array of objects`);
    }

    const linkedSources = (await Promise.all(flows.filter(flow => flow.version == 1).map(async (flow) => {
        const linkedSources = await getSupportedSources({
            debug,
            baseUri: clientApiBaseUri,
            env,
            flow: flow.id,
            apikey,
        });
        return linkedSources;
    }))).flat();

    const newSourceIds = forkedSources.map((source) => {
      if (!source.tap) {
        throw new Error(`Source ${JSON.stringify(source)} has no tap id`);
      }
      return source.tap;
    });
    const duplicateIds = newSourceIds.filter((id, index) => newSourceIds.indexOf(id) !== index);
    if (duplicateIds.length > 0) {
      throw new Error(`Duplicate source id(s) found in availableSources.json: ${duplicateIds.join(', ')}. All sources must have a unique tap id.`);
    }


    const missingSources = linkedSources.filter((source) => source.isForked && !newSourceIds.includes(source.tap));

    if (missingSources.length > 0) {
      throw new Error(`Sources ${missingSources.map((source) => source.label).join(', ')} are linked, but missing from your availableSources.json`);
    }
}


export const validateAvailableTargets = async (forkedTargets, clientApiBaseUri, apikey, flows, env) => {
    if (!Array.isArray(forkedTargets)) {
      throw new Error(`availableTargets.json must be an array of objects`);
    }

    const linkedTargets = (await Promise.all(flows.filter(flow => flow.version == 1).map(async (flow) => {
        const linkedTargets = await getSupportedTargets({
            debug,
            baseUri: clientApiBaseUri,
            env,
            flow: flow.id,
            apikey,
        });
        return linkedTargets;
    }))).flat();

    const newTargetIds = forkedTargets.map((target) => {
      if (!target.target) {
        throw new Error(`Target ${JSON.stringify(target)} has no target id`);
      }
      return target.target;
    });
    const duplicateIds = newTargetIds.filter((id, index) => newTargetIds.indexOf(id) !== index);
    if (duplicateIds.length > 0) {
      throw new Error(`Duplicate target id(s) found in availableTargets.json: ${duplicateIds.join(', ')}. All targets must have a unique target id.`);
    }
    
    const missingTargets = linkedTargets.filter((target) => target.isForked && !newTargetIds.includes(target.target));

    if (missingTargets.length > 0) {
      throw new Error(`Targets ${missingTargets.map((target) => target.label).join(', ')} are linked, but missing from your availableTargets.json`);
    }
}

export const validateAvailableConnectors = async (forkedConnectors, clientApiBaseUri, apikey, flows, env) => {
    if (!Array.isArray(forkedConnectors)) {
      throw new Error(`availableConnectors.json must be an array of objects`);
    }

    const linkedConnectors = (await Promise.all(flows.filter(flow => flow.version == 2).map(async (flow) => {
        const linkedConnectors = await getSupportedConnectors({
            debug,
            baseUri: clientApiBaseUri,
            env,
            flow: flow.id,   
            apikey,
        });
        return linkedConnectors;
    }))).flat();


    const newConnectorIds = forkedConnectors.map((connector) => {
      if (!connector.id) {
        throw new Error(`Connector ${JSON.stringify(connector)} has no id`);
      }
      return connector.id;
    });
    const duplicateIds = newConnectorIds.filter((id, index) => newConnectorIds.indexOf(id) !== index);
    if (duplicateIds.length > 0) {
      throw new Error(`Duplicate connector id(s) found in availableConnectors.json: ${duplicateIds.join(', ')}. All connectors must have a unique id.`);
    }

    const missingConnectors = linkedConnectors.filter((connector) => {
      return connector.isForked && !newConnectorIds.includes(connector.id)
    });
    
    
    if (missingConnectors.length > 0) {
        throw new Error(`Connectors ${missingConnectors.map((connector) => connector.id).join(', ')} are linked, but missing from your availableConnectors.json`);
    }
}

